import {InjectionToken} from '@angular/core';

export interface Settings {
  production: boolean;
}

export type SettingsRef<T extends Settings> = {
  [key in keyof T]: T[key];
};

export const SETTINGS = new InjectionToken<SettingsRef<Settings>>('lv-settings');
